import {Button, SelectItem} from '@mantine/core'
import axios from 'axios'
import {useEffect, useState} from 'react'
import {Col, Modal, Row} from 'react-bootstrap'
import {API_BASE_URL} from '../../../utils/contants'
import InputErrorBox from '../../components/InputErrorBox'
import Select2 from '../../components/select2'
import {setupAxios, useAuth} from '../../modules/auth'
import {cancelSubmit, handleInputChange, handleSubmit, validateForm} from './UserFunction'
import {getDesignationData, getEmploymentTypeData} from '../../CommonFunction'
import API from '../../../api/APIUrl'
// import ShiftManagement from '../ShiftManagement/ShiftManagement'
// import { response } from 'express'

const CreateUser = ({closeModal, user, setUser, fetchUsers}) => {
  const {currentUser} = useAuth()

  const [editId, setEditId] = useState(null)
  const [inputError, setInputError] = useState<any>({})
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })
  const initialState = {
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    contact: '',
    password: '',
    dob: '',
    gender: '',
    address: '',
    permanentAddress: '',   //Permant Address
    department: '', 
    departmentId: null, 
    employeeCode: 'CTR-',
    employmentType: '',
    designation: '',
    startDate: '',
    endDate: '',
    role: '',
    inTime: '',
    outTime: '',
    reportingManager: '',
    personalEmail: '',
    hr: '',
    band: null,

    //Emergency Contact Fetch
    emergencyName: '',
    emergencyMobile: '',
    emergencyRelation: '',

    shiftManagement: '',  //Shift Management
    locationId: '', //Location Master
    weekendDays: [] as string[],
    isPoshCommitteeMember: false, //POSH Committee Member
    partner: currentUser?.role?.name === 'PARTNER' ? currentUser?.id : null,

  }

  //const [inputField, setInputField] = useState(initialState)
  const [inputField, setInputField] = useState<typeof initialState>(initialState)
  const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false)
  const [usersOptions, setUsersOptions] = useState<{label: string; value: string}[]>([])
  const sortedUserNames = usersOptions.slice().sort((a, b) => a.label.localeCompare(b.label))
  
  //###########################################################################################################S
  //Select Shift Drop Down
  type ShiftOption ={
    label: string
    value: string
    // startTime: string
    // endTime: string
    meta: {
      startTime: string
      endTime: string
    }
  }
  const [shiftOptions, setShiftOptions] = useState<ShiftOption[]>([])

  //const [shiftOptions, setShiftOptions] = useState<{label: string; value: string}[]>([])

  //-----------Weekend Days----------
  const WEEK_DAYS = [
    { label: 'Mon', value: 'Monday' },
    { label: 'Tue', value: 'Tuesday' },
    { label: 'Wed', value: 'Wednesday' },
    { label: 'Thu', value: 'Thursday' },
    { label: 'Fri', value: 'Friday' },
    { label: 'Sat', value: 'Saturday' },
    { label: 'Sun', value: 'Sunday' },
  ]


  //  ----------Location Master---------
  type LocationOption = {
    label: string
    value: string
  }
  const [locationOptions, setLocationOptions] = useState<LocationOption[]>([])

  // Custom handler for employee code to maintain CTR- prefix
  const handleEmployeeCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    
    // If user tries to delete the CTR- prefix, restore it
    if (!value.startsWith('CTR-')) {
      setInputField((prevInputField) => ({
        ...prevInputField,
        employeeCode: 'CTR-' + value.replace(/^CTR-?/, '')
      }))
    } else {
      // Only allow 4 digits after CTR-
      const afterPrefix = value.slice(4)
      if (afterPrefix.length <= 4 && /^\d*$/.test(afterPrefix)) {
        setInputField((prevInputField) => ({
          ...prevInputField,
          employeeCode: value
        }))
      }
    }
  }

  const [band, setBand] = useState<SelectItem[]>([])
  const [designation, setDesignation] = useState<SelectItem[]>([])
  const [employmentType, setEmploymentType] = useState<SelectItem[]>([])

  const [role, setURoles] = useState<{label: string; value: string}[]>([])
  const sortedRoles = role.slice().sort((a, b) => a.label.localeCompare(b.label))
  const fetchRoles = () => {
    const {token, tenantId} = setupAxios()
    axios
      .get(API_BASE_URL + `/${API.ROLE}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          // 'X-Tenant-Id': `${tenantId}`,
        },
      })
      .then((response: any) => {
        let userData: {label: string; value: string}[] = []

        response.data.data.map((obj: {name: string; id: string}) => {
          if (obj?.name !== 'PARTNER') {
            userData.push({
              label: obj.name,
              value: obj.id,
            })
          }
        })

        setURoles(userData)
      })
      .catch((error) => {
        // Handle error silently or use proper error handling
      })
  }
  const fetchuser = () => {
    const {token, tenantId} = setupAxios()
    axios
      .get(API_BASE_URL + `/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response: any) => {
        let userData: {label: string; value: string}[] = []

        response.data.data.map((obj: {email: string; id: string}) => {
          userData.push({
            label: obj.email,
            value: obj.id,
          })
        })

        setUsersOptions(userData)
      })
      .catch((error) => {
        // Handle error silently or use proper error handling
      })
  }
  const [departments, setDepartments] = useState<{label: string; value: string}[]>([])
const sortedDepartments = departments.slice().sort((a, b) => a.label.localeCompare(b.label))

 const fetchDepartments = () => {
  const { token } = setupAxios()
  axios
    .get(API_BASE_URL + '/departments', { headers: { Authorization: `Bearer ${token}` } })
    .then((response: any) => {
      const data = response?.data?.data
      if (Array.isArray(data)) {
        const deptOptions = data.map((dept: { id: string; name: string }) => ({
          label: dept.name,
          value: dept.id,
        }))
        setDepartments(deptOptions)
      } else {
        console.warn('Department data is not an array', data)
        setDepartments([])
      }
    })
    .catch((error) => {
      console.error('Error fetching departments:', error)
      setDepartments([])
    })
}
  const [hr, setHr] = useState<{label: string; value: string}[]>([])
  const sortedHr = hr.slice().sort((a, b) => a.label.localeCompare(b.label))
  const fetchHr = () => {
    const {token, tenantId} = setupAxios()
    axios
      .get(API_BASE_URL + `/users/hr`, {
        headers: {
          Authorization: `Bearer ${token}`,
          // 'X-Tenant-Id': `${tenantId}`,
        },
      })
      .then((response: any) => {
        let userData: {label: string; value: string}[] = []

        userData = response.data.data.map(
          (obj: {firstName: string; lastName: string; id: string}) => ({
            label: `${obj.firstName} ${obj.lastName}`,
            value: obj.id,
          })
        )

        setHr(userData)
      })
      .catch((error) => {
        // Handle error silently or use proper error handling
      })
  }

  //Add User Inside shift Dropdown
    const fetchShiftManagement = () => {
      const { token } = setupAxios()

      axios
        .get(API_BASE_URL + '/shift-management', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response: any) => {
          const shiftData = response.data.data.items.map(
            (shift: any) => ({
              label: shift.label, // already formatted in backend
              value: shift.id,
              meta:{
                startTime: shift.startTime,// Shift bases auto fetch to Intime
                endTime: shift.endTime, // Shift bases auto fetch to Outtime
              }
            })
          )

          setShiftOptions(shiftData)
        })
        .catch(() => {
        })
      }

      // Add User Inside Location Dropdown
      const fetchLocations = () => {
      const { token } = setupAxios()

      axios
        .get(API_BASE_URL + '/location-master?active=true', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response: any) => {
          const locations = response.data.data.map((loc: any) => ({
            label: `${loc.name}${loc.city ? ' - ' + loc.city : ''}`,
            value: loc.id,
          }))

          setLocationOptions(locations)
        })
        .catch(() => {})
    }



  // const [user, setUser] = useState({
  //   id: '',
  //   firstName: '',
  //   lastName: '',
  //   email: '',
  //   contact: '',
  //   password: '',
  //   dob: '',
  //   gender: '',
  //   employmentType: '',
  //   designation: '',
  //   startDate: '',
  //   endDate: '',
  //   inTime: '',
  //   outTime: '',
  //   reportingManager: {
  //     firstName: '',
  //     lastName: '',
  //   },

  //   personalEmail: '',
  // })
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
  })
  const [] = useState<any>({})

  const handleClose = () => {
    closeModal()
    setInputError({})
    setSameAsCurrentAddress(false)
    setInputField(initialState)
  }

  useEffect(() => {
    let mounted = true
    if (mounted) {
      fetchuser()
      fetchRoles()
      fetchHr()
      fetchShiftManagement()   ////Shift Dropdown inside Add user
      fetchDepartments()
      // fetchBand()
      fetchLocations()  // Location Master
      getDesignationData(setDesignation)
      getEmploymentTypeData(setEmploymentType)
      // getUser(setUser, setAPIStatus)
      // fetchUsers()
    }
    // if (!SubmitAPIStatus.loading) {
    //   fetchuser()
    // }

    return () => {
      mounted = false
    }
  }, [])

  return (
    <>
      {/* Add user modal form */}
      <Modal
        className='modal-lg'
        show={true}
        animation={false} // Disable the default modal animation
        backdrop='static' // Keep the backdrop open when clicking outside the modal
        onHide={handleClose}
      >
        {/* add user heading-modal header*/}
        <div className='modal-header'>
          <h2 className='fw-bolder'>Add User</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-bs-placement='top'
            title='Close'
            data-kt-users-modal-action='close'
            onClick={handleClose}
            style={{cursor: 'pointer'}}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        {/*begin::Form*/}
        <div className='m-3'>
          {/* Personal Information Section */}
          <div className='mb-5'>
            <h5 className='fw-bold mb-3 text-gray-800'>Personal Information</h5>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>First Name</label>
                <input
                  placeholder='First Name'
                  className='form-control'
                  type='text'
                  name='firstName'
                  autoComplete='off'
                  value={inputField.firstName}
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                {<InputErrorBox Message={inputError.firstName} />}
              </Col>
              <Col md={6}>
                <label className="required fw-bold fs-6 mb-2">Middle Name</label>
                <input
                  placeholder="Middle Name"
                  className="form-control"
                  type="text"
                  name="middleName"
                  required
                  value={inputField.middleName}
                  onChange={(e) => handleInputChange(e, setInputField, inputField)}
                />
                <InputErrorBox Message={inputError.middleName} />
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Last Name</label>
                <input
                  placeholder='Last Name'
                  className='form-control'
                  type='text'
                  name='lastName'
                  value={inputField.lastName}
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                {<InputErrorBox Message={inputError.lastName} />}
              </Col>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Date of Birth</label>
                <input
                  className='form-control'
                  type='date'
                  name='dob'
                  value={inputField.dob}
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                {<InputErrorBox Message={inputError.dob} />}
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Gender</label>
                <div className='d-flex mt-2'>
                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='radio'
                      id='male'
                      name='gender'
                      value='male'
                      checked={inputField.gender === 'male'}
                      onChange={(event) => {
                        handleInputChange(event, setInputField, inputField)
                      }}
                    />
                    <label htmlFor='male' className='fw-bold text-gray-800 d-block me-3'>
                      Male
                    </label>
                  </div>
                  <div className='form-check' style={{paddingRight: '20px'}}>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='gender'
                      placeholder='radio1'
                      value='female'
                      id='female'
                      checked={inputField.gender === 'female'}
                      onChange={(event) => {
                        handleInputChange(event, setInputField, inputField)
                      }}
                    />
                    <label htmlFor='female' className=' fw-bold text-gray-800 d-block'>
                      Female
                    </label>
                  </div>
                  <div className='form-check' style={{ paddingRight: '20px' }}>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='gender'
                      value='other'
                      id='other'
                      checked={inputField.gender === 'other'}
                      onChange={(event) => {
                        handleInputChange(event, setInputField, inputField)
                      }}
                    />
                    <label htmlFor='other' className='fw-bold text-gray-800 d-block'>
                      Other
                    </label>
                  </div>
                </div>
                <InputErrorBox Message={inputError.gender} />
              </Col>
            </Row>
          </div>

          {/* Contact Information Section */}
          <div className='mb-5'>
            <h5 className='fw-bold mb-3 text-gray-800'>Contact Information</h5>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Organization Email</label>
                <input
                  className='form-control'
                  placeholder='Organization Email'
                  type='email'
                  name='email'
                  value={inputField.email}
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                {<InputErrorBox Message={inputError.email} />}
              </Col>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Personal Email</label>
                <input
                  className='form-control'
                  placeholder='Personal Email'
                  type='email'
                  name='personalEmail'
                  value={inputField.personalEmail}
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                {<InputErrorBox Message={inputError.personalEmail} />}
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Mobile Number</label>
                <input
                  placeholder='Mobile Number'
                  className={`form-control ${inputError.contact ? 'is-invalid' : ''}`}
                  type='tel'
                  name='contact'
                  inputMode='numeric'
                  maxLength={10}
                  pattern='[6-9][0-9]{9}'
                  value={inputField.contact}
                  aria-invalid={Boolean(inputError.contact)}
                  onChange={(event) => {
                    handleInputChange(event, setInputField, inputField)
                    setInputError((previous: any) => ({...previous, contact: ''}))
                  }}
                />
                {<InputErrorBox Message={inputError.contact} />}
              </Col>
              {/* Password field commented out - password will be auto-generated by system and sent via email
                  Auto-generated password requirements: One capital letter, one special character, one small letter */}
              {/* <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Password</label>
                <input
                  placeholder='Password'
                  className='form-control'
                  type='password'
                  name='password'
                  value={inputField.password || ''}
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                {<InputErrorBox Message={inputError.password} />}
              </Col> */}
            </Row>
          </div>

          {/* Employment Information Section */}
          <div className='mb-5'>
            <h5 className='fw-bold mb-3 text-gray-800'>Employment Information</h5>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Employment Type</label>
                <div className='col-12'>
                  <Select2
                    name='employmentType'
                    data={employmentType}
                    value={inputField.employmentType}
                    onChange={(selectedOption: any) => {
                      setInputField((prevInputField) => ({
                        ...prevInputField,
                        employmentType: selectedOption,
                      }))
                    }}
                  />
                  {<InputErrorBox Message={inputError.employmentType} />}
                </div>
              </Col>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Designation</label>
                <div className='col-12'>
                  <Select2
                    name='designation'
                    data={designation}
                    value={inputField.designation}
                    onChange={(selectedOption: any) => {
                      setInputField((prevInputField) => ({
                        ...prevInputField,
                        designation: selectedOption,
                      }))
                    }}
                  />
                  <InputErrorBox Message={inputError.designation} />
                </div>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Department</label>
                <div className='col-12'>
                  <Select2
                    data={sortedDepartments}
                    value={inputField.departmentId}
                    onChange={(selectedOption: any) => {
                      setInputField((prev) => ({
                        ...prev,
                        departmentId: selectedOption,
                      }))
                    }}
                    name='departmentId'
                  />
                  <InputErrorBox Message={inputError.departmentId} />
                </div>
              </Col>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Role</label>
                <div className='col-12'>
                  <Select2
                    data={sortedRoles}
                    value={inputField.role}
                    onChange={(selectedOption: any) => {
                      setInputField((prevInputField) => ({
                        ...prevInputField,
                        role: selectedOption,
                      }))
                    }}
                    name='role'
                    disabled={false}
                  ></Select2>
                  {<InputErrorBox Message={inputError.role} />}
                </div>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Reporting Manager</label>
                <div className='col-12'>
                  <Select2
                    data={sortedUserNames}
                    value={inputField.reportingManager}
                    onChange={(selectedOption: any) => {
                      setInputField((prevInputField) => ({
                        ...prevInputField,
                        reportingManager: selectedOption,
                      }))
                    }}
                    name='reportingManager'
                    disabled={false}
                  ></Select2>
                  {<InputErrorBox Message={inputError.reportingManager} />}
                </div>
              </Col>
              <Col md={6}>
                <label className='fs-6 fw-semibold mb-2'>Human Resource</label>
                <div className='col-12'>
                  <Select2
                    data={sortedHr}
                    value={inputField.hr}
                    onChange={(selectedOption: any) => {
                      setInputField((prevInputField) => ({
                        ...prevInputField,
                        hr: selectedOption,
                      }))
                    }}
                    name='hr'
                  ></Select2>
                </div>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Date of Joining</label>
                <input
                  className='form-control'
                  type='date'
                  value={inputField.startDate}
                  name='startDate'
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                <InputErrorBox Message={inputError.startDate} />
              </Col>
              <Col md={6}>
                <label className=' fw-bold fs-6 mb-2'>Date of Leaving</label>
                <input
                  className='form-control'
                  type='date'
                  autoComplete='off'
                  name='endDate'
                  value={inputField.endDate}
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                {<InputErrorBox Message={inputError.endDate} />}
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Employee Code</label>
                <input
                  placeholder='CTR-1111'
                  className='form-control'
                  type='text'
                  name='employeeCode'
                  value={inputField.employeeCode}
                  onChange={handleEmployeeCodeChange}
                  maxLength={8}
                />
                {<InputErrorBox Message={inputError.employeeCode} />}
                <div className='text-muted fs-7'>Format: CTR-1111 (CTR- prefix with 4 digits). Code should be same as biometric employee code</div>
              </Col>
            </Row>
          </div>

          {/* Work Schedule Section */}
          <div className='mb-5'>
            <h5 className='fw-bold mb-3 text-gray-800'>Work Schedule</h5>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Select Shift</label>
                <div className='col-12'>
                  <Select2
                    name="shiftManagement"
                    data={shiftOptions}
                    value={inputField.shiftManagement}
                    onChange={(shiftId: string | null) => {
                      const selectedShift = shiftOptions.find(
                        (shift) => shift.value === shiftId
                      )
                      setInputField((prev) => ({
                        ...prev,
                        shiftManagement: shiftId ?? '',
                        inTime: selectedShift?.meta.startTime ?? '',
                        outTime: selectedShift?.meta.endTime ?? '',
                      }))
                    }}
                  />
                  <InputErrorBox Message={inputError.shiftManagement} />
                </div>
              </Col>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Select Office Location</label>
                <div className='col-12'>
                  <Select2
                    name='locationId'
                    data={locationOptions}
                    value={inputField.locationId}
                    onChange={(selectedOption: any) => {
                      setInputField((prev) => ({
                        ...prev,
                        locationId: selectedOption,
                      }))
                    }}
                  />
                  <InputErrorBox Message={inputError.locationId} />
                </div>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Week-Off</label>
                <div className="d-flex flex-wrap gap-3">
                  {WEEK_DAYS.map((day) => (
                    <label key={day.value} className="form-check d-flex align-items-center gap-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={inputField.weekendDays.includes(day.value)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          let updated = [...inputField.weekendDays];
                          if (checked) {
                            if (updated.length >= 2) {
                              setInputError((prev: any) => ({
                                ...prev,
                                weekendDays: 'Maximum 2 Week Off allowed',
                              }));
                              return;
                            }
                            updated.push(day.value);
                          } else {
                            updated = updated.filter((d) => d !== day.value);
                          }
                          setInputError((prev: any) => ({
                            ...prev,
                            weekendDays: '',
                          }));
                          setInputField((prev) => ({
                            ...prev,
                            weekendDays: updated,
                          }));
                        }}
                      />
                      <span>{day.label}</span>
                    </label>
                  ))}
                </div>
                <InputErrorBox Message={inputError.weekendDays} />
                <div className="text-muted fs-7">
                  Select minimum 1 and maximum 2 days
                </div>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>In Time</label>
                <input
                  className='form-control'
                  type='time'
                  value={inputField.inTime}
                  name='inTime'
                  readOnly
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                <InputErrorBox Message={inputError.inTime} />
                <div className='text-muted fs-7 mt-1'>
                  Shifts will be automatically managed based on work timings
                </div>
              </Col>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Out Time</label>
                <input
                  className='form-control'
                  type='time'
                  value={inputField.outTime}
                  name='outTime'
                  readOnly
                  onChange={(event) => handleInputChange(event, setInputField, inputField)}
                />
                <InputErrorBox Message={inputError.outTime} />
              </Col>
            </Row>
          </div>

          {/* Address Information Section */}
          <div className='mb-5'>
            <h5 className='fw-bold mb-3 text-gray-800'>Address Information</h5>
            <Row className='mb-4'>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Current Address</label>
                <input
                  placeholder='Address'
                  className={`form-control ${inputError.address ? 'is-invalid' : ''}`}
                  type='text'
                  name='address'
                  maxLength={255}
                  value={inputField.address}
                  aria-invalid={Boolean(inputError.address)}
                  onChange={(event) => {
                    handleInputChange(event, setInputField, inputField)
                    setInputError((previous: any) => ({...previous, address: ''}))
                  }}
                />
                {<InputErrorBox Message={inputError.address} />}
              </Col>
              <Col md={6}>
                <label className='required fw-bold fs-6 mb-2'>Permanent Address</label>
                <input
                  placeholder='Permanent Address'
                  className={`form-control ${inputError.permanentAddress ? 'is-invalid' : ''}`}
                  type='text'
                  name='permanentAddress'
                  maxLength={255}
                  value={inputField.permanentAddress}
                  aria-invalid={Boolean(inputError.permanentAddress)}
                  onChange={(event) => {
                    handleInputChange(event, setInputField, inputField)
                    setInputError((previous: any) => ({...previous, permanentAddress: ''}))
                  }}
                />
                <InputErrorBox Message={inputError.permanentAddress} />
                <div className='mt-2'>
                  <input
                    type="checkbox"
                    checked={sameAsCurrentAddress}
                    onChange={(e) => {
                      setSameAsCurrentAddress(e.target.checked)
                      if (e.target.checked) {
                        setInputField(prev => ({
                          ...prev,
                          permanentAddress: prev.address
                        }))
                      } else {
                        setInputField(prev => ({ ...prev, permanentAddress: '' }))
                      }
                    }}
                  />
                  <span className="ms-2">Same as current address</span>
                </div>
              </Col>
            </Row>
          </div>

          {/* Emergency Contact Section */}
          <div className='mb-5'>
            <h5 className='fw-bold mb-3 text-gray-800'>Emergency Contact</h5>
            <Row className='mb-4'>
              <Col md={6}>
                <label className="required fw-bold fs-6 mb-2">Emergency Contact Name</label>
                <input
                  className={`form-control ${inputError.emergencyName ? 'is-invalid' : ''}`}
                  type="text"
                  name="emergencyName"
                  maxLength={100}
                  value={inputField.emergencyName}
                  aria-invalid={Boolean(inputError.emergencyName)}
                  onChange={(e) => {
                    handleInputChange(e, setInputField, inputField)
                    setInputError((previous: any) => ({...previous, emergencyName: ''}))
                  }}
                  placeholder="Enter emergency contact name"
                />
                <InputErrorBox Message={inputError.emergencyName} />
              </Col>
              <Col md={6}>
                <label className="required fw-bold fs-6 mb-2">Emergency Mobile</label>
                <input
                  className="form-control"
                  type="tel"
                  name="emergencyMobile"
                  value={inputField.emergencyMobile}
                  onChange={(e) => handleInputChange(e, setInputField, inputField)}
                  placeholder="+918390870115"
                />
                <InputErrorBox Message={inputError.emergencyMobile} />
                <div className='text-muted fs-7'>
                  Format: First enter the country code (e.g. +91) followed by the emergency contact number.
                  e.g: +918390870115
                </div>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col md={6}>
                <label className="required fw-bold fs-6 mb-2">Relation</label>
                <input
                  className={`form-control ${inputError.emergencyRelation ? 'is-invalid' : ''}`}
                  type="text"
                  name="emergencyRelation"
                  maxLength={50}
                  value={inputField.emergencyRelation}
                  aria-invalid={Boolean(inputError.emergencyRelation)}
                  onChange={(e) => {
                    handleInputChange(e, setInputField, inputField)
                    setInputError((previous: any) => ({...previous, emergencyRelation: ''}))
                  }}
                  placeholder="Father / Mother / Spouse"
                />
                <InputErrorBox Message={inputError.emergencyRelation} />
              </Col>
            </Row>
          </div>

          {/* Additional Information Section */}
          <div className='mb-5'>
            <h5 className='fw-bold mb-3 text-gray-800'>Additional Information</h5>
            <Row className='mb-4'>
              <Col md={6}>
                <label className="fw-bold fs-6 mb-2">Member of POSH Committee</label>
                <div className="d-flex gap-4 mt-2">
                  <label className="form-check d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isPoshCommitteeMember"
                      checked={inputField.isPoshCommitteeMember === true}
                      onChange={(e) => {
                        setInputField((prev) => ({
                          ...prev,
                          isPoshCommitteeMember: true,
                        }))
                      }}
                    />
                    <span>Yes</span>
                  </label>
                  <label className="form-check d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isPoshCommitteeMember"
                      checked={inputField.isPoshCommitteeMember === false}
                      onChange={(e) => {
                        setInputField((prev) => ({
                          ...prev,
                          isPoshCommitteeMember: false,
                        }))
                      }}
                    />
                    <span>No</span>
                  </label>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className='form m-5'>
          <div className='text-center'>
            {/* begin:: discard button */}
            <button
              type='reset'
              className='btn btn-light me-3 btn-sm'
              data-kt-users-modal-action='cancel'
              onClick={() => {
                setInputField(initialState)
                setSameAsCurrentAddress(false)
                setInputError({})
              }}
            >
              Clear
            </button>

            {/* end:: discard button */}

            {/* begin:: modal-form save button */}
            <Button
              type='submit'
              loading={SubmitAPIStatus.loading}
              className='btn btn-sm  btn-primary'
              onClick={() =>{
                console.log("🔥 BEFORE SUBMIT departmentId:", inputField.departmentId)
                console.log("🔥 BEFORE SUBMIT FULL:", inputField)
                handleSubmit(
                  {
                    ...inputField,
                    currentUserEmail: currentUser?.email ?? null,
                    
                  },
                  // inputField,
                  // getUser,
                  setUser,
                  setEditId,
                  initialState,
                  setInputField,
                  editId,
                  cancelSubmit,
                  setAPIStatus,
                  // setShowForm,
                  setInputError,
                  validateForm,
                  setSubmitAPIStatus,
                  handleClose,
                  fetchUsers
                  // currentUser?.email
                )
              }
            }
            >
              Save
            </Button>

            {/* end:: modal-form save button */}
          </div>
          {/* <Message type="success">Success</Message> */}
        </div>
      </Modal>
    </>
  )
}

export default CreateUser
